import {
  type ChangeEventHandler,
  type KeyboardEvent,
  useRef,
  useState,
} from 'react'

import { EMAIL_REGEX } from '@/constants/constants'

export const useEmailState = (
  initial: string,
  onSubmit: (next: string) => void
) => {
  const ref = useRef<HTMLInputElement | null>(null)
  const [state, setState] = useState(initial)

  const isValid = EMAIL_REGEX.test(state.trim())
  const disabled = !isValid || state.trim() === initial

  const handleSubmit = () => {
    if (disabled) {
      return
    }
    onSubmit(state.trim())
    ref.current?.blur()
  }

  const handleKeyUp = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSubmit()
    }
    if (event.key === 'Escape') {
      setState(initial)
      ref.current?.blur()
    }
  }

  const onChange: ChangeEventHandler<HTMLInputElement> = (ev) =>
    setState(ev.target.value)

  return { ref, handleKeyUp, handleSubmit, state, disabled, onChange }
}
